import { AIconSize } from '../../atoms/AIcon/AIcon.types';
import { MLogoContainerSize } from '../MLogoContainer/MLogoContainer.types';
import { DACImage } from '../../utils/ImageUtils';

export enum MBrandElementType {
  Logo = 'Logo',
  Icon = 'Icon',
  Image = 'Image',
}

export interface MBrandElementProps {
  type: MBrandElementType;
  brand?: string;
  logoColor?: 'background-aware' | 'color';
  logoSize?: MLogoContainerSize;
  iconSize?: AIconSize;
  icon?: string;
  image?: DACImage;
}
